(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/hooks/use-drag.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/hooks/use-drag.js');

'use strict';

const {
  useCallback,
  useEffect,
  useState,
  useRef
} = React;
const DragState = Object.freeze({
  START: 'drag-start',
  DRAGGING: 'drag-active',
  END: 'drag-end',
  IDLE: 'drag-idle'
});
const MouseEvents = Object.freeze({
  START: 'mousedown',
  MOVE: 'mousemove',
  STOP: 'mouseup'
});
const TouchEvents = Object.freeze({
  START: 'touchstart',
  MOVE: 'touchmove',
  STOP: 'touchend'
});
const supportsTouch = () => {
  if ('ontouchstart' in window) {
    return true;
  }

  if (window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }
  return window.matchMedia('(pointer: coarse)').matches;
};
const useDrag = (ref, onStart, onMove, onEnd, onRelease) => {
  const [status, setStatus] = useState(DragState.IDLE);
  const [touch, setTouch] = useState(() => supportsTouch());
  const mouse = useRef({
    x: 0,
    y: 0
  });
  const enabled = useRef(true);
  const trackHandlers = useRef([]);
  let onStartCallback = onStart;
  let onMoveCallback = onMove;
  let onEndCallback = onEnd;
  let onReleaseCallback = onRelease;
  const DeviceEvent = touch ? TouchEvents : MouseEvents;
  const getLocationFromEvent = useCallback(e => ({
    x: touch ? e.changedTouches[0].clientX : e.pageX,
    y: touch ? e.changedTouches[0].clientY : e.pageY
  }), [touch]);
  const handleMove = useCallback(e => {
    var _onMoveCallback;
    if (enabled.current) {
      e.preventDefault();
    }
    const p = getLocationFromEvent(e);
    const dist = {
      x: p.x - mouse.current.x,
      y: p.y - mouse.current.y
    };
    (_onMoveCallback = onMoveCallback) === null || _onMoveCallback === void 0 || _onMoveCallback(dist);
  }, [getLocationFromEvent, onMoveCallback]);
  const handleEnd = useCallback(e => {
    var _onEndCallback;
    if (enabled.current && e.type === MouseEvents.START) {
      e.preventDefault();
    }
    const p = getLocationFromEvent(e);
    const dist = {
      x: p.x - mouse.current.x,
      y: p.y - mouse.current.y
    };
    window.removeEventListener(DeviceEvent.MOVE, handleMove);
    window.removeEventListener(DeviceEvent.STOP, handleEnd);
    setStatus(DragState.END);
    requestAnimationFrame(() => setStatus(DragState.IDLE));
    (_onEndCallback = onEndCallback) === null || _onEndCallback === void 0 || _onEndCallback(dist);
  }, [DeviceEvent, getLocationFromEvent, handleMove, onEndCallback]);
  const handleStart = useCallback(e => {
    var _onStartCallback;
    if (!enabled.current) {
      return;
    }
    if (e.type === MouseEvents.START) {
      e.preventDefault();
    }
    if (e.target.closest('button') || e.target.closest('a')) {
      return;
    }
    mouse.current = getLocationFromEvent(e);
    window.removeEventListener(DeviceEvent.MOVE, handleMove);
    window.removeEventListener(DeviceEvent.STOP, handleEnd);
    window.addEventListener(DeviceEvent.MOVE, handleMove, {
      passive: false
    });
    window.addEventListener(DeviceEvent.STOP, handleEnd, {
      passive: false
    });
    setStatus(DragState.START);
    requestAnimationFrame(() => setStatus(DragState.DRAGGING));
    (_onStartCallback = onStartCallback) === null || _onStartCallback === void 0 || _onStartCallback(mouse.current);
  }, [DeviceEvent, getLocationFromEvent, handleEnd, handleMove, onStartCallback]);
  const enable = () => enabled.current = true;
  const disable = () => enabled.current = false;
  const release = () => {
    var _onReleaseCallback;
    window.removeEventListener(DeviceEvent.MOVE, handleMove);
    window.removeEventListener(DeviceEvent.STOP, handleEnd);
    (_onReleaseCallback = onReleaseCallback) === null || _onReleaseCallback === void 0 || _onReleaseCallback();
  };
  const registerCallbacks = _ref => {
    let {
      onStart,
      onMove,
      onEnd,
      onRelease
    } = _ref;
    onStartCallback = onStart || onStartCallback;
    onMoveCallback = onMove || onMoveCallback;
    onEndCallback = onEnd || onEndCallback;
    onReleaseCallback = onRelease || onReleaseCallback;
  };
  useEffect(() => {
    const handleResize = () => {
      const t = supportsTouch();
      if (touch !== t) {
        setTouch(t);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [touch]);
  useEffect(() => {
    const element = (ref === null || ref === void 0 ? void 0 : ref.current) || ref;
    if (element && element instanceof Element) {
      trackHandlers.current.push(DeviceEvent.START);
      element.addEventListener(DeviceEvent.START, handleStart, {
        passive: false
      });
    }
    const handlers = trackHandlers.current;
    return () => {
      while (handlers.length) {
        element === null || element === void 0 || element.removeEventListener(handlers.pop(), handleStart);
      }
    };
  }, [DeviceEvent.START, handleStart, ref]);
  return {
    enable,
    disable,
    release,
    registerCallbacks,
    status
  };
};
setGlobal('svs.components.carousel.hooks', {
  DragState,
  useDrag,
  supportsTouch
});

 })(window);